import React, { useState, useEffect } from "react";
import * as Constants from "../../../../utils/constants";
import "./BookLoadModal.scss";
import { useTranslation } from "react-i18next";
import { CustomModalWeb } from "../../../pages/userProfile/CustomModalWeb";

export const BookLoadConfirmModal = (props: any) => {
  const { t } = useTranslation();

  const [confirmModal, setConfirmModal] = useState(false);
  const confirmBookLoadOk = (): void => {
    setConfirmModal(false);
    props.confirmBookLoad();
  };

  const thankyouButtonClick = (clickType: string) => {
    setConfirmModal(false);
    props.confirmBookLoad();
    props.updateClickType(clickType);
  };

  const titleReturnHandler = () => {
    if (props.bookLoadResponse?.status === Constants.BOOKLOAD_STATUS_OK) {
      return Constants.BOOKLOAD_THANKYOU_HEADER;
    }
    else if (props.bookLoadResponse?.status === Constants.BOOKLOAD_STATUS_REJECTED) {
      return Constants.BOOKLOAD_REQUEST_REJECTED_HEADER;
    }
    else if (props.bookLoadResponse?.status === Constants.BOOKLOAD_ONHOLD) {
      return Constants.BOOKLOAD_ON_HOLD;
    }
    else if (props.bookLoadResponse?.status === Constants.BOOKLOAD_CANCELLED) {
      return Constants.BOOKLOAD_CANCELLED_MESSAGE;
    }
    else if (props.bookLoadResponse?.status === Constants.BOOKLOAD_TIMEOUT) {
      return Constants.BOOKLOAD_THANKYOU_HEADER;
    }
    else return null;
  }

  useEffect(() => {
    setConfirmModal(props.confirmModal);
  }, [props.confirmModal]);
  const bookLoadConfirmModalProps = {
    isModalOpen: confirmModal,
    title: titleReturnHandler(),
    message:
      props.bookLoadResponse?.status === Constants.BOOKLOAD_STATUS_OK ? (
        `<div>
          <div className="load-id-message">
            ${t("NEW_BOOKLOAD_THANK_YOU_MESSAGE")}
          <strong>${props?.loadId}!</strong>
        </Trans>
          </div>
          <div className="load-id-subText">
            ${t("NEW_BOOKLOAD_THANK_YOU_MESSAGE_SUB_TEXT")}
          </div>
          <p className="load-id-description">
            ${t("NEW_BOOKLOAD_THANK_YOU_DESCRIPTION")}
          </p>
        </div>`
      ) : props.bookLoadResponse?.status ===
        Constants.BOOKLOAD_STATUS_REJECTED ? (
        props.bookLoadResponse?.message
      ) : props.bookLoadResponse?.status === Constants.BOOKLOAD_ONHOLD ||
        Constants.BOOKLOAD_CANCELLED ||
        Constants.BOOKLOAD_TIMEOUT ? (
        props.bookLoadResponse?.message
      ) : null,
    buttons:
      props.bookLoadResponse?.status === Constants.BOOKLOAD_STATUS_OK
        ? [
          {
            title: t("VIEW_MORE_RESULTS"),
              type: "secondary-cta-btn-web extra-width",
              "data-test-id" : "view-more-results",
            onClick: () => thankyouButtonClick("viewMoreResults")
          },
          {
            title: t("ASSIGN_DRIVER"),
            type: "primary-cta-btn-web",
              "data-test-id" : "assign-driver",
            onClick: () => thankyouButtonClick("assignDriver")
          }
        ]
        : [
          {
            title: t("Ok_TEXT"),
            type: "primary-cta-btn-web",
              "data-test-id" : "confirm-bookload",
            onClick: () => confirmBookLoadOk()
          }
        ],
    contentScroll: "deny",
    size: props.bookLoadResponse?.status !== Constants.BOOKLOAD_STATUS_OK ? "extra_small_height" : null
  };
  return <CustomModalWeb {...bookLoadConfirmModalProps} />;
};

export const GetShipmentModal = (props: any) => {
  const [isGetShipmentModal, setisGetShipmentModal] = useState(
    props.isGetShipmentModal
  );
  useEffect(() => {
    setisGetShipmentModal(props.isGetShipmentModal);
  }, [props.isGetShipmentModal]);
  const getShipmentOk = () => {
    setisGetShipmentModal(false);
    props.declineBookLoad();
  };
  const { t } = useTranslation();

  const bookLoadAssignmentErrorModalProps = {
    isModalOpen: isGetShipmentModal,
    title: Constants.BOOKLOAD_THANKYOU_HEADER,
    message_content: Constants.BOOKLOAD_THANK_YOU_ERROR_MESSAGE,
    contentScroll: "deny",
    buttons: [
      {
        title: t("Ok_TEXT"),
        type: "primary-cta-btn-web",
        "data-test-id" : "getShipment",
        onClick: () => getShipmentOk()
      }
    ]
  };
  return <CustomModalWeb {...bookLoadAssignmentErrorModalProps} />;
};
